import { render, staticRenderFns } from "./DataListMoleculeComponent.vue?vue&type=template&id=0245fa1f&scoped=true&"
import script from "./DataListMoleculeComponent.vue?vue&type=script&lang=js&"
export * from "./DataListMoleculeComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataListMoleculeComponent.vue?vue&type=style&index=0&id=0245fa1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0245fa1f",
  null
  
)

export default component.exports